<template>
  <div class="learner_feeds">
    <!-- Milestones -->
    <div class="row long_row milestone" v-if="currentProgram.trackCertificate">

    <div class="col-12 sub_hd_bar">
      <div class="sub_hd_ic">
        <div class="ic ic26-milestone"></div>
      </div>
      <div class="hd_txt prog_txt">
        {{getMilestonesLabel()}}
      </div>
    </div>

      <div class="col-12">
        <div class="card ace_sec crd_cal">

          <div class="card-body">
            <div class="row quick_link">
              <template v-for="(milestone, i) in currentProgram.children" >
                <div class="col-5 milestone_block">
                  <div class="progress-row" :title="milestone.description">
                    <div class="progress-bar-label ace_sec_txt" :aria-label="milestone.title">
                      {{milestone.title}}
                    </div>
                    <b-progress :max="milestone.total">
                      <b-progress-bar :value="milestone.completed" class="prog_bar__completed">
                      </b-progress-bar>
                      <b-progress-bar :value="milestone.inProgress" class="prog_bar__in_progress">
                      </b-progress-bar>
                    </b-progress>
                  </div>
                </div>
                <div class="steps_sep" v-if="i<currentProgram.children.length-1">
                  <span class="ic ic24-arr_next"></span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Milestones  -->

    <!-- Quick Links -->
    <div class="row long_row recommended_msg_row" v-if="links.length>0">
      <div class="col-12">

        <div class="card ace_sec crd_cal">
          <div class="card-body">

            <div class="row">
              <div class="col-2 row_icon">
                <div class="icon ic24-link"></div>
              </div>
              <div class="col-12 row_detail">
                <div class="row cal_detail">
                  <div class="col-12 block_row row_title ace_sec">
                    {{getQuickLinksLabel()}}
                  </div>
                  <div class="col-12 block_row ace_sec" v-for="(link, i) in links" >
                    <b-link @click="launchQuickLink(link.url)" v-if="i<showLinkSize">{{link.title}}</b-link>
                  </div>
                  <div class="col-12 lnk_container">
                    <b-link @click="showAllLink"  v-if="links.length>showLinkSize">{{links.length-showLinkSize}} more {{getQuickLinksLabel()}}</b-link>
                    <b-link @click="showLimitedLink"  v-if="showLinkSize>2 && links.length<=showLinkSize">show limited {{getQuickLinksLabel()}}</b-link>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- End Quick Links -->
    <!-- Recommendation Event -->
    <div class="row long_row recommended_msg_row" v-if="lastRecommendedMessage">
      <div class="col-12">

        <div class="card ace_sec crd_cal">
          <div class="card-body">

            <div class="row">
              <div class="col-2 row_icon">
                <div class="icon fas fa-user">
                </div>
              </div>
              <div class="col-12 row_detail">
                <div class="row cal_detail">
                  <div class="col-12 block_row row_title ace_sec">
                    {{lastRecommendedMessage.message.name}}
                  </div>
                  <div class="col-12 block_row ace_sec" v-html="lastRecommendedMessage.message.text">
                  </div>
                  <div class="col-12 block_row lnk_container ace_sec" v-if="unreadCountState > 1">
                    <b-link @click="navigateToChannel">{{unreadCountState}} unread messages</b-link>
                  </div>
                  <div class="col-12 block_row lnk_container ace_sec" v-if="unreadCountState == 1">
                    <b-link @click="navigateToChannel">read message</b-link>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- Recommendation Event -->

    <!-- Calendar Events -->
    <div class="row long_row" v-if="nextCalendarEvents.length > 0">
      <div class="col-12">

        <div class="card ace_sec crd_cal">
          <div class="card-body">
            <div class="row">
              <div class="col-2 row_icon">
                <div class="ic ic11-dateRange">
                </div>
              </div>
              <div class="col-10 row_detail">
                <div class="row cal_detail">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12 block_row row_title">
                        {{nextCalendarEvents[0].title}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 block_row">
                        <span class="label">When:</span> {{nextCalendarEvents[0].formattedStartDateTime}}
                      </div>
                      <div class="col-12 block_row">
                        <span class="label">Where:</span> {{nextCalendarEvents[0].location}}
                      </div>
                      <div class="col-12 lnk_container">
                        <b-link @click="navigateToEvent">more calendar events</b-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Calendar Events Ends -->

    <!-- Feeds  -->
    <div class="row long_row" v-for="(feed, i) in feeds">
      <div class="col-12">

        <div class="card ace_sec crd_cal">
          <div class="card-body">
            <div class="row">
              <div class="col-2 row_icon" v-if="feed.iconUrl">
                  <img v-bind:src="feed.iconUrl" width="22" height="22">
              </div>
              <div class="col-2 row_icon" v-else>
                <div class="ic ic11-club">
                </div>
              </div>
              <div class="col-10 row_detail">
                <div class="row cal_detail">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12 block_row row_title">
                        {{feed.title}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 block_row " v-if="feed.description" v-html="trimDesc(feed.description)">
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 block_row">
<!--                        <span class="label" v-if="feed.startDate">When:</span> {{feed.startDate}}
-->
                      </div>
                      <div class="col-12 block_row" v-if="feed.address">
                        <span class="label">Where:</span>  {{feed.address}}
                      </div>
                      <div class="col-12 lnk_container">
                        <b-link @click="launch(feed)" v-if="feed.entityType==='PATHWAY' ">explore pathway</b-link>
                        <b-link @click="launch(feed)" v-else-if="feed.entityType==='EXPLORE' ">explore career</b-link>
                        <b-link @click="launch(feed)" v-else-if="feed.entityType==='EXPLORE_PROGRAM' ">explore programs</b-link>
                        <b-link @click="launch(feed)" v-else>more detail</b-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Feeds Ends -->
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { db, storage } from '../../../firebase'
  export default {
    name: 'learner-feeds',
    data: () => {
      return {
        nextCalendarEvents: [],
        messages: [],
        recommendations: [],
        test: {},
        moreRecommendations : 0,
        feeds: [],
        links: [],
        showLinkSize : 2,
        currentProgram : {}
      }
    },
    mounted () {
      this.loadLearnerFeed()
    },
    beforeMount () {
      this.$root.$on('reloadCompetencyProgress', (data) => {
        this.populateProgram(data)
      })
      this.$root.$on('reloadLearnerDashboard', () => {
        this.loadLearnerFeed()
      })
    },

    methods: {
      ...mapActions([
        'loadGetNextCalendarEvent',
        'loadFeedsForStudent',
        'loadRecommendationsForStudent',
        'loadQuickLinks',
        'loadProgramTracking'
      ]),
      async populateProgram (data) {
          this.currentProgram = await this.loadProgramTracking(data.programCode)
      },
      getMilestonesLabel (){
          return this.getFlagLabel('learner_dashboard', 'Show Milestones', 'Milestones')
      },
      getFlagLabel (featureId, flagValue, defaultLabel) {
        let learnerDB = this.enabledFeatures[featureId]
        if (learnerDB && learnerDB.enabled) {
          let flags = learnerDB.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === flagValue) {
              return flags[i].label
            }
          }
        }
        return defaultLabel;
      },
      async loadLearnerFeed () {
        this.nextCalendarEvents = await this.loadGetNextCalendarEvent()
        this.recommendations = await this.loadRecommendationsForStudent()
        this.feeds = await this.loadFeedsForStudent()
        this.links = await this.loadQuickLinks('QUICKLINK')
      },
      navigateToChannel () {
        return this.$router.push({name: 'channel', params: {uuid: this.userObj.uuid, selectedCurrentChannel: this.lastRecommendedMessage.channel, channelType: 'ALL'}})
      },
      navigateToEvent () {
        return this.$router.push({name: 'calendarEventList'})
      },
      trimDesc (desc){
        if(desc && desc.length>110){
            desc = desc.substring(0,110)
            let lastSpace = desc.lastIndexOf(" ")
            desc = desc.substring(0,lastSpace)
            desc += " ..."
        }
        return desc
      },
      getQuickLinksLabel () {
      let quickLinks = this.enabledFeatures['quick_links']
      return quickLinks && quickLinks.label? quickLinks.label:'Quick Links'
    },
      launchQuickLink(url){
        window.open(url, '_blank')
      },
      showAllLink () {
        this.showLinkSize = this.links.length
      },
      showLimitedLink () {
        this.showLinkSize = 2
      },
      launch (feed){
        if(feed.entityType ==='event' && feed.url){
          window.open(feed.url, '_blank')
        }
        if(feed.entityType !=='event' && feed.url){
          this.$router.push(feed.url)
        }
      }
    },
    computed: {
      ...mapState({
        'unreadCountState': state => state.dashboard.unreadCountState,
        'enabledFeatures': state => state.dashboard.enabledFeatures,
        'userObj': state => state.login.userObj
      }),
      lastRecommendedMessage () {
        if (this.recommendations) {
          for (const [key, value] of Object.entries(this.recommendations)) {
            let messages = this.recommendations[key]
            if (messages.length > 0) {
            this.moreRecommendations = messages.length-1
              return {
                'channel': key,
                'message': messages[0]
              }
            }
          }
        }
        return null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerFeeds.vue